
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "ember-cli-sass/-embroider-implicit-modules.js";
import "ember-data/-embroider-implicit-modules.js";
import "ember-data/-embroider-implicit-modules.js";
import "ember-classic-decorator/-embroider-implicit-modules.js";
import "ember-intl/-embroider-implicit-modules.js";
import "@square/dashboard-translations/-embroider-implicit-modules.js";
import "ember-copy/-embroider-implicit-modules.js";
import "@square/dashboard-money/-embroider-implicit-modules.js";
import "@square/ember-optimizely/-embroider-implicit-modules.js";
import "ember-data-model-fragments/-embroider-implicit-modules.js";
import "ember-data-relationship-tracker/-embroider-implicit-modules.js";
import "@square/dashboard-data/-embroider-implicit-modules.js";
import "@square/dashboard-protos/-embroider-implicit-modules.js";
import "@square/dashboard-utilities/-embroider-implicit-modules.js";
import "@square/ember-features/-embroider-implicit-modules.js";
